import React from 'react';
import Controls from './Controls';
import SeriesBlock from './SeriesBlock';
import LoadingWheel from './LoadingWheel';
import Pagination from 'react-js-pagination';
import {MediaLibrary as ML} from 'FW/Models/MediaLibrary';
import {Helper} from '../../../Helpers';

class MediaLibrarySeries extends React.Component {
  constructor(props) {
    super(...arguments);
    let library = FW.store.get(
      'section-' + props.section.get('id') + '-library'
    );
    let series = FW.store.get('section-' + props.section.get('id') + '-series');
    series.addQuery({hidden: 0}, 'unhidden');
    this.state = {
      section: props.section,
      library: library,
      series: series,
      filters: {},
      activePage: 1,
      activeFile: null,
      lastPageSize: props.section.prop('options').page_size || 15,
      libraryID: props.section.get('properties').media_library_id
    };
    let qs = new URLSearchParams(window.location.search);
    this.filtersChanged = this.filtersChanged.bind(this);
    this.onSort = this.onSort.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    if (FW.inEditor()) {
      this.addButtonToSection();
    }
    props.section.on(
      'reboot',
      () => {
        this.state.series.resetSearch();
        this.state.series.setPageSize(
          props.section.prop('options').page_size || 15,
          () => {
            this.state.series.trigger('sync');
            this.setState({
              activePage: this.state.series.pagination
                ? this.state.series.pagination.number
                : 1,
              loading: false
            });
          }
        );
      },
      this
    );
  }

  componentDidMount() {
    let libSeries = this.state.series;
    let pageSize = this.props.section.prop('options')
      ? this.props.section.prop('options').page_size || 15
      : 15;
    let orderBy = this.props.section.prop('options')
      ? this.props.section.prop('options').sort_by || 'display_date'
      : 'display_date';
    let orderDir = this.props.section.prop('options')
      ? this.props.section.prop('options').sort_direction || 'DESC'
      : 'DESC';
    libSeries.on(
      'sync',
      () => {
        this.setState({
          series: libSeries,
          loading: false
        });
      },
      this
    );
    libSeries.allLoaded = true; // because everything is loaded in media library section helper
    libSeries.setPageSize(pageSize);
    this.addFileListeners(this.state.series);
    if (!this.state.library.get('created_at')) {
      this.setState({
        libraryNotFound: true
      });
    }
    this.state.series.on('error', (series, e) => {
      if (e.status === 404) {
        this.setState({
          libraryNotFound: true
        });
      }
    });
  }

  addButtonToSection() {
    let section = this.props.section;
    let user = window.parent.FW.store.get('user')
      ? window.parent.FW.store.get('user')
      : null;
    if (user && user.may('edit_media_library', this.state.library)) {
      section._editButtons = [
        {
          title: 'Edit Media Library',
          class: 'glyphicon-pencil',
          type: 'btn-default',
          action: () => {
            this.editLibrary();
          }
        }
      ];
    }
  }

  editLibrary() {
    window.parent.FW.editor.setMode('editLibrary', 'editLibrary', {
      library: this.state.library,
      remount: true,
      onSave: () => {
        this.props.section.reboot();
      }
    });
  }

  componentDidUpdate() {
    let pageSize = this.props.section.prop('options')
      ? this.props.section.prop('options').page_size || 15
      : 15;
    let libraryID = this.props.section.get('properties').media_library_id;
    if (
      pageSize !== this.state.lastPageSize ||
      libraryID !== this.state.libraryID
    ) {
      let library = ML.findOrCreate({id: libraryID});
      let libSeries = this.state.series;
      this.setState(
        {
          libraryNotFound: false,
          lastPageSize: pageSize,
          loading: true,
          activePage: 1,
          libraryID: libraryID,
          library: library
        },
        () => {
          this.addFileListeners(libSeries);
          libSeries.setPageSize(pageSize, () => {
            this.setState({
              loading: false
            });
          });
        }
      );
    }
  }

  addFileListeners(libSeries) {
    libSeries.off(null, null, this);
    libSeries.on(
      'sync',
      () => {
        this.setState({
          series: libSeries,
          loading: false
        });
      },
      this
    );
  }

  componentWillUnmount() {
    this.state.series.off(null, null, this);
    this.props.section.off(null, null, this);
  }

  filtersChanged(filters) {
    let qs = new URLSearchParams(window.location.search);
    qs.set('year', filters.year);
    window.history.pushState(
      filters,
      null,
      window.location.pathname + '?' + qs.toString() + window.location.hash
    );

    this.state.series.addQuery(filters);
    this.setState({
      loading: true,
      activePage: 1
    });
    this.state.series.fetch();
  }

  onSort(field, order) {
    this.setState({
      loading: true
    });
    this.state.series.sortByField(field, order);
    this.state.series.fetch({reset: true});
  }

  handlePageChange(page) {
    this.setState({
      loading: true
    });
    let top = $(this.div).offset().top;
    $('html, body').animate({scrollTop: top - 70 + 'px'}, 500);
    this.state.series.getPage(page, () => {
      this.setState({
        activePage: page,
        loading: false
      });
    });
  }

  render() {
    const options = this.state.section.prop('options') || {};
    const customColors = this.state.section.ls('use_custom_colors')
      ? {
          description: {
            color: this.state.section.ls('description_color')
          },
          title: {
            color: this.state.section.ls('title_color')
          },
          background: {
            background: this.state.section.ls('background_color')
              ? Helper.convertHexToRGBA(
                  this.state.section.ls('background_color'),
                  this.state.section.ls('background_opacity') * 100
                )
              : null
          },
          backgroundHover: {
            background: this.state.section.ls('background_hover_color')
              ? Helper.convertHexToRGBA(
                  this.state.section.ls('background_hover_color'),
                  this.state.section.ls('background_hover_opacity') * 100
                )
              : null
          },
          overlay: {
            background: this.state.section.ls('overlay_color')
              ? Helper.convertHexToRGBA(
                  this.state.section.ls('overlay_color'),
                  this.state.section.ls('overlay_opacity') * 100
                )
              : null
          }
        }
      : null;
    let series =
      this.state.series && this.state.series.models
        ? this.state.series.getCurrentPage().map((series, i) => {
            return (
              <SeriesBlock
                key={i}
                customColors={customColors}
                showThumbnail={this.state.section.prop('show_thumbnails')}
                series={series}
              />
            );
          })
        : [];
    let pagination = this.state.series ? this.state.series.pagination : {};
    return (
      <div
        className="FWMediaSection standard-layout"
        style={options.font ? {fontFamily: options.font} : {}}
        ref={c => {
          this.div = c;
        }}
      >
        {this.state.libraryNotFound ? (
          <div
            style={{
              paddingTop: 150,
              paddingBottom: 150,
              paddingLeft: 10,
              paddingRight: 10,
              textAlign: 'center',
              background: '#ccc',
              borderRadius: 5,
              marginLeft: 20,
              marginRight: 20
            }}
          >
            <p className="lead">Media Library Not Found</p>
            {FW.inEditor() ? (
              <p className="lead">
                You can edit this section&apos;s properties to select a library.
              </p>
            ) : null}
          </div>
        ) : (
          <div>
            {/*{this.state.series && !this.props.section.prop('hide_control_bar') ? <Controls section={this.props.section} library={this.state.library} onChange={this.filtersChanged} onSort={this.onSort} /> : null}*/}

            <div
              className="files"
              style={{position: 'relative', width: '100%'}}
            >
              {series}
              {this.state.activePage === 1 && series.length === 0 ? (
                <div style={{width: '100%', padding: 50, textAlign: 'center'}}>
                  <p className="lead">
                    This library does not yet have any files with series.
                  </p>
                  {FW.inEditor() ? (
                    <p className="lead" style={{fontSize: '1.2em'}}>
                      You can add series to files in this library by hovering
                      over it and clicking the &quot;Edit Media Library&quot;
                      pencil on the upper-right.
                    </p>
                  ) : null}
                </div>
              ) : null}
              <div style={{textAlign: 'center', width: '100%'}}>
                <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={pagination.size || 10}
                  totalItemsCount={pagination.total || 10}
                  pageRangeDisplayed={options.num_pages_listed || 15}
                  onChange={this.handlePageChange}
                />
              </div>

              {this.state.loading ? (
                <div
                  style={{
                    position: 'absolute',
                    width: 'calc(100% - 20px)',
                    height: 'calc(100% - 20px)',
                    margin: '10px',
                    background: 'rgba(93, 93, 93, 0.61)',
                    borderRadius: '5px'
                  }}
                >
                  <LoadingWheel style={{top: 100}} />
                </div>
              ) : null}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default MediaLibrarySeries;
